module.exports = __webpack_public_path__ + "static/pulse-e35db4bd07d7f6d7a0ef0b2b1480626c.svg";